
import { enqueueSnackbar } from "notistack";

 
const showErrorToast = (title) => {
    enqueueSnackbar(title, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 3000,
      })
};
 

export const showSubscriptionSuccessToast = (message) => {
    enqueueSnackbar(message, {
        variant: 'success',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 7000,
      })
};

export const showSuccessToast = (title) => {
    enqueueSnackbar(title, {
        variant: 'success',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 3000,
      })
};


export default showErrorToast;
 